export default "__VITE_ASSET__DDK8ZT_m__"